var exports = {
  "p": "x1cb7f6e3--c63791--list",
};

module.exports = exports;
